export { default as EmployeeDocuments } from './EmployeeDocuments/EmployeeDocuments';
export { default as CompanyDocuments } from './CompanyDocuments/CompanyDocuments';
export { default as OnboardingDocuments } from './OnboardingDocuments/OnboardingDocuments';
export { default as TaskList } from './TaskList/TaskList';
export { default as Toaster } from './Toaster/Toaster';
export { default as CreateTemplate } from './CreateTemplate/CreateTemplate';
export { default as EditDocument } from './EditDocument/EditDocument/EditDocument';
export { default as UploadDocument } from './UploadDocument/UploadDocument';
export { default as SimpleSignDocuments } from './SimpleSignDocuments/SimpleSignDocuments';
export { default as CompanyPlan } from './CompanyPlan/CompanyPlan';
export { default as SignatureNotification } from './SignatureNotification/SignatureNotification';



// WEBPACK FOOTER //
// ./src/containers/index.js